export default __webpack_public_path__ + "static/media/5-min.05d7886f.jpg";